class AboutTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-tab-target]'));
    this.panels = Array.from(this.querySelectorAll('.about-story__panel'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.activate(tab));
    });
  }

  activate(tab) {
    const targetId = tab.dataset.tabTarget;

    this.tabs.forEach((t) => {
      const isActive = t === tab;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      panel.classList.toggle('is-active', panel.id === targetId);
    });
  }
}

customElements.define('about-tabs', AboutTabs);
